import React from "react";
import styles from "./Login.module.css";

export const LoginWrapper = ({ children }) => {
  return (
    <div className={styles.LoginBgWrapper}>
      <div className={styles.LoginBg}></div>
      <div className={styles.LoginWrapper}>{children}</div>
    </div>
  );
};
